@if (profileScoreService.error()) {
  <lib-error-and-retry
    [errorMessage]="'profile-score.error.message' | translate"
    [labelButton]="'profile-score.error.button' | translate"
    [labelError]="'profile-score.error.label-error' | translate"
    [isLoadingState]="profileScoreService.isLoading()"
    (retry)="profileScoreService.getCustomerScore(country())"
  />
} @else {
  @if (!profileScoreService.isLoading() && profileScoreService.scoreProfileComputed(); as data) {
    <!-- Banner de Cadastro Completo -->
    @if (data.completeRegistration) {
      <div class="complete-registration-banner">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27" fill="none">
        <path d="M10 26.5127L0 19.0127V0H20V19.0127L10 26.5127ZM10 24L18 18.0127V2H2V18.0127L10 24ZM8.6 16.205L15.6717 9.13333L14.2667 7.68733L8.6 13.354L5.77433 10.5283L4.32833 11.9333L8.6 16.205ZM10 2H2H18H10Z" fill="#008200"/>
        </svg>
        <span>{{ 'profile-score.complete_registration_banner' | translate }}</span>
      </div>
    }

    @if (isShowProfileScore()) {
    <div class="profile-score-card">
      <lib-title
        [text]="'profile-score.complete_your_profile' | translate"
        tag="h2" />

      <!-- Barra de Progresso -->
      <div class="progress-container">
        <div class="progress-bar">
          <div
            class="progress-fill"
            [class.complete]="data.progressBar.percent === 100"
            [style.width.%]="data.progressBar.percent">
          </div>
        </div>
        <span class="progress-percentage">{{ data.progressBar.percent }}%</span>
      </div>

      <!-- Status de Conclusão -->
      <div class="status-row">
        <span>{{"profile-score.level" | translate}} {{ data.progressBar.currentStep }}</span>
        <button class="details-button" (click)="toggleDetails()">
          {{ 'profile-score.details' | translate }}
          <svg
            class="arrow-icon"
            [class.rotated]="showDetails()"
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="#00095B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Detalhes Expansíveis -->
      @if (showDetails()) {
        <div class="profile-score-details">
          <!-- Nível 1: Dados pessoais -->
            <lib-profile-level-section
            [title]="'profile-score.level.1'"
            [levelItems]="levelItems.personalData"
            [levelData]="data.personalData"
            [modalConfigService]="modalConfigService"
            (linkClicked)="onLinkClicked($event)"
          />

          <!-- Nível 2: Dados de contato -->
          <lib-profile-level-section
            [title]="'profile-score.level.2'"
            [levelItems]="levelItems.contactDetails"
            [levelData]="data.contactDetails"
            [modalConfigService]="modalConfigService"
            (linkClicked)="onLinkClicked($event)"
          />

          <!-- Nível 3: Veículo -->
          <lib-profile-level-section
            [title]="'profile-score.level.3'"
            [levelItems]="levelItems.vehicle"
            [levelData]="data.vehicle"
            [modalConfigService]="modalConfigService"
            (linkClicked)="onLinkClicked($event)"
          />

          <!-- Nível 4: Carro conectado e concessionária -->
          <lib-profile-level-section
            [title]="(isActiveConnectedCarComputed() ? 'profile-score.level.4_connected_car' : 'profile-score.level.4_disconnected_car')"
            [levelItems]="levelItems.carConnectedDealer"
            [levelData]="data.carConnectedDealer"
            [modalConfigService]="modalConfigService"
            (linkClicked)="onLinkClicked($event)"
          />
        </div>
      }
    </div>
    }

    <!-- Modal único para todos os itens -->
    @if (showModal() && selectedModalConfig(); as config) {
      <app-dialog [opened]="true" (openedChange)="closeModal()">
        <lib-profile-modal-content
          [title]="config.inputs.title"
          [subtitle]="config.inputs.subtitle!"
          [steps]="config.inputs.steps"
          [buttonText]="config.inputs.buttonText!"
          (buttonClick)="closeModal()"
        />
      </app-dialog>
    }
  } @else {
    <!-- Loading State -->
    <div class="profile-score-card">
      <lib-title
        [text]="'profile-score.complete_your_profile' | translate"
        tag="h2" />

      <lib-ui-shimmer-fragment type="rectangle" height="20" width="100" marginBottom="15" />

      <lib-ui-shimmer-fragment type="rectangle" height="25" width="55" marginBottom="15" />
    </div>
  }
}
